import React from 'react';
import { PaginationContainer } from './style/pagination.styled';


interface PaginationControlsProps {
    page: number;
    totalPages: number;
    setPage: (page: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({ page, totalPages, setPage }) => {
    const handlePrevious = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    const renderPages = () => {
        return Array.from({ length: totalPages }, (_, index) => index + 1)
            .filter((pageNumber) => {
                return (
                    pageNumber === 1 ||
                    pageNumber === totalPages ||
                    pageNumber === page ||
                    pageNumber === page - 1 ||
                    pageNumber === page + 1
                );
            })
            .map((pageNumber, index, array) => (
                <React.Fragment key={pageNumber}>
                    {index > 0 && pageNumber !== array[index - 1] + 1 && (
                        <span key={`ellipsis-${pageNumber}`}>...</span>
                    )}
                    <button
                        onClick={() => setPage(pageNumber)}
                        disabled={page === pageNumber}
                    >
                        {pageNumber}
                    </button>
                </React.Fragment>
            ));
    };

    return (
        <PaginationContainer>
            <button onClick={handlePrevious} disabled={page === 1}>
                Anterior
            </button>

            {renderPages()}

            <button onClick={handleNext} disabled={page === totalPages}>
                Próximo
            </button>
        </PaginationContainer>
    );
};

export default PaginationControls;
